import { FC, useEffect, useState } from 'react'
import { Input } from '../Input/Input'
import { LittleButton } from '../Button/LittleButton'
import { CreateLojaAgregadorDTO,UpdateLojaAgregadorDTO, RedeSocial } from '../../pages/Agregador/lojas/type'
import { Loading } from '../Loading/Loading'

type Props = {
  next: () => void
  back: () => void
  data: CreateLojaAgregadorDTO | UpdateLojaAgregadorDTO
  setData: (value: CreateLojaAgregadorDTO | UpdateLojaAgregadorDTO) => any
  setRedeSocialParent: (value: RedeSocial[]) => any
}


const LinksLoja: FC<Props> = ({ next, back, data, setData, setRedeSocialParent }) => {
 const [loading,setLoading] = useState<boolean>(true)
  //Campos dos Links
  const [facebookLink, setFacebookLink] = useState('')
  const [facebookStatus, setFacebookStatus] = useState<boolean>(false)

  const [instagramLink, setInstagramLink] = useState('')
  const [instagramStatus, setInstagramStatus] = useState<boolean>(false)

  const [whatsappLink, setWhatsappLink] = useState('')
  const [whatsappStatus, setWhatsappStatus] = useState<boolean>(false)

  const [linkedinLink, setLinkedinLink] = useState('')
  const [linkedinStatus, setLinkedinStatus] = useState<boolean>(false)

  const [youtubeLink, setYoutubeLink] = useState('')
  const [youtubeStatus, setYoutubeStatus] = useState<boolean>(false)

  const [googlemapsLink, setGoogleMapsLink] = useState('')
  const [googlemapsStatus, setGoogleMapsStatus] = useState<boolean>(false)

  function nextPage() {
    const newRedeSocial = setAllRedeSocial()
    setRedeSocialParent(newRedeSocial)
    const newData = data
    newData.config.redesSociais = newRedeSocial
    setData(newData)

    next()
  }

  useEffect(() => {
    const updatedSocialLinks = [
      {
        status: facebookStatus,
        link: facebookLink,
        type: 'facebook',
      },
      {
        status: instagramStatus,
        link: instagramLink,
        type: 'instagram',
      },
      {
        status: whatsappStatus,
        link: whatsappLink,
        type: 'whatsapp',
      },
      {
        status: linkedinStatus,
        link: linkedinLink,
        type: 'linkedin',
      },
      {
        status: youtubeStatus,
        link: youtubeLink,
        type: 'youtube',
      },
      {
        status: googlemapsStatus,
        link: googlemapsLink,
        type: 'googlemaps',
      },
    ]

    setRedeSocialParent(updatedSocialLinks)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    facebookLink,
    facebookStatus,
    instagramLink,
    instagramStatus,
    whatsappLink,
    whatsappStatus,
    linkedinLink,
    linkedinStatus,
    youtubeLink,
    youtubeStatus,
    googlemapsLink,
    googlemapsStatus,
  ])

  function setAllRedeSocial(): RedeSocial[] {
    try {
      return [
        {
          status: facebookStatus,
          link: facebookLink,
          type: 'facebook',
        },
        {
          status: instagramStatus,
          link: instagramLink,
          type: 'instagram',
        },
        {
          status: whatsappStatus,
          link: whatsappLink,
          type: 'whatsapp',
        },
        {
          status: linkedinStatus,
          link: linkedinLink,
          type: 'linkedin',
        },
        {
          status: youtubeStatus,
          link: youtubeLink,
          type: 'youtube',
        },
        {
          status: googlemapsStatus,
          link: googlemapsLink,
          type: 'googlemaps',
        },
      ]
    } catch (error) {
      return []
    }
  }

  function backPage() {
    const newRedeSocial = setAllRedeSocial()
    const newData = data
    newData.config.redesSociais = newRedeSocial

    setRedeSocialParent(newRedeSocial)
    setData(newData)
    back()
  }


  function showLinks() {
    if (data.config.redesSociais && data.config.redesSociais.length > 0) {
    
      setFacebookLink(data.config.redesSociais.find((el: any) => el.type === 'facebook')?.link ?? '')
      setFacebookStatus(data.config.redesSociais.find((el: any) => el.type === 'facebook')?.status ?? false)

      setInstagramLink(data.config.redesSociais.find((el: any) => el.type === 'instagram')?.link ?? '')
      setInstagramStatus(data.config.redesSociais.find((el: any) => el.type === 'instagram')?.status ?? false)

      setWhatsappLink(data.config.redesSociais.find((el: any) => el.type === 'whatsapp')?.link ?? '')
      setWhatsappStatus(data.config.redesSociais.find((el: any) => el.type === 'whatsapp')?.status ?? false)

      setLinkedinLink(data.config.redesSociais.find((el: any) => el.type === 'linkedin')?.link ?? '')
      setLinkedinStatus(data.config.redesSociais.find((el: any) => el.type === 'linkedin')?.status ?? false)

      setYoutubeLink(data.config.redesSociais.find((el: any) => el.type === 'youtube')?.link ?? '')
      setYoutubeStatus(data.config.redesSociais.find((el: any) => el.type === 'youtube')?.status ?? false)

      setGoogleMapsLink(data.config.redesSociais.find((el: any) => el.type === 'googlemaps')?.link ?? '')
      setGoogleMapsStatus(data.config.redesSociais.find((el: any) => el.type === 'googlemaps')?.status ?? false)
    } 

    setTimeout(()=> setLoading(false),1000)
  }

  useEffect(() => {
    showLinks()
  }, [])

  if(loading){
    return <Loading />
  }

  return (
    <div className='card mt-5' style={{ padding: '2rem 5rem', gap: '44px' }}>
      <div>
        <h3>Links da Loja Externa</h3>
        <span>Aqui você configura Links e Redes sociais da loja Externa.</span>
      </div>
      <div className='d-flex flex-column ' style={{ gap: '72px' }}>
        <div className='row ' style={{ marginTop: '14px' }}>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>
              <i
                className='bi bi-facebook '
                style={{
                  fontSize: '30px',
                }}
              ></i>
            </div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='Facebook'
                value={facebookStatus}
                checked={facebookStatus}
                change={(value: any) => {
                  setFacebookStatus(value)
                  // changeArray('facebook','status',value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={facebookLink}
                change={(value: any) => {
                  // changeArray('facebook','link',value)
                  setFacebookLink(value)
                }}
              />
            </div>
          </div>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>
              <i
                className='bi bi-instagram '
                style={{
                  fontSize: '30px',
                }}
              ></i>
            </div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='Instagram'
                value={instagramStatus}
                checked={instagramStatus}
                change={(value: any) => {
                  // changeArray('instagram','status',value)
                  setInstagramStatus(value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={instagramLink}
                change={(value: any) => {
                  // changeArray('instagram','link',value)
                  setInstagramLink(value)
                }}
              />
            </div>
          </div>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>
              <i
                className='bi bi-whatsapp '
                style={{
                  fontSize: '30px',
                }}
              ></i>
            </div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='WhatsApp'
                value={whatsappStatus}
                checked={whatsappStatus}
                change={(value: any) => {
                  // changeArray('whatsapp','status',value)
                  setWhatsappStatus(value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={whatsappLink}
                change={(value: any) => {
                  // changeArray('whatsapp','link',value)
                  setWhatsappLink(value)
                }}
              />
            </div>
          </div>
        </div>
        <div className='row ' style={{ marginTop: '14px' }}>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>
              {vendaOnline}
            </div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='Compre online'
                value={linkedinStatus}
                checked={linkedinStatus}
                change={(value: any) => {
                  // changeArray('linkedin','status',value)
                  setLinkedinStatus(value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={linkedinLink}
                change={(value: any) => {
                  // changeArray('linkedin','link',value)
                  setLinkedinLink(value)
                }}
              />
            </div>
          </div>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>
              <i
                className='bi bi-youtube '
                style={{
                  fontSize: '30px',
                }}
              ></i>
            </div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='Youtube'
                value={youtubeStatus}
                checked={youtubeStatus}
                change={(value: any) => {
                  // changeArray('youtube','status',value)
                  setYoutubeStatus(value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={youtubeLink}
                change={(value: any) => {
                  // changeArray('youtube','link',value)
                  setYoutubeLink(value)
                }}
              />
            </div>
          </div>
          <div className='col d-flex' style={{ gap: '12px' }}>
            <div className='d-flex justify-content-center align-items-start mt-3'>{mapsIcon}</div>
            <div>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label='GoogleMaps'
                value={googlemapsStatus}
                checked={googlemapsStatus}
                change={(value: any) => {
                  // changeArray('googlemaps','status',value)
                  setGoogleMapsStatus(value)
                }}
              />
              <Input
                inputAttr={{
                  type: 'link',
                }}
                value={googlemapsLink}
                change={(value: any) => {
                  // changeArray('googlemaps','link',value)
                  setGoogleMapsLink(value)
                }}
              />
            </div>
          </div>
        </div>

        <div className='row ' style={{ marginTop: '14px' }}>
          <div className='d-flex  gap-5 justify-content-between mt-5'>
            <LittleButton
              text={'voltar'}
              color={'info'}
              click={() => backPage()}
              width='110px'
              height='35px'
            />
            <LittleButton
              text={'Salvar'}
              color={'primary'}
              click={() => nextPage()}
              width='110px'
              height='35px'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export { LinksLoja }

const mapsIcon = (
  <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.3277 7.55666C19.3277 6.6771 19.6346 5.92493 20.2546 5.30015C20.8745 4.68143 21.6209 4.37207 22.4936 4.37207C23.3664 4.37207 24.1127 4.68143 24.7267 5.30015C25.3466 5.92493 25.6596 6.6771 25.6596 7.55666C25.6596 8.43621 25.3466 9.18838 24.7267 9.81316C24.1127 10.4319 23.3664 10.7473 22.4936 10.7412C21.6209 10.7412 20.8745 10.4319 20.2546 9.81316C19.6346 9.18838 19.3277 8.43621 19.3277 7.55666Z'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M29 7.55721C29 11.1785 22.6801 18.5425 22.4935 18.3605C22.3069 18.1786 15.9871 11.1785 15.9871 7.55721C15.9871 3.93588 18.9002 1 22.4935 1C26.0868 1 29 3.93588 29 7.55721Z'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M27.1222 12.7612C27.3328 13.7014 27.4412 14.678 27.4412 15.6789C27.4412 23.0368 21.5246 28.9995 14.2236 28.9995C6.92263 28.9995 1 23.0428 1 15.6849C1 8.32701 6.91661 2.36426 14.2176 2.36426C15.5538 2.36426 16.8479 2.56443 18.0637 2.93445'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path d='M2.13158 21.2601L15.8547 7.42383' stroke='#677484' stroke-miterlimit='10' />
    <path d='M10.0704 13.4346L22.3671 25.8272' stroke='#677484' stroke-miterlimit='10' />
  </svg>
)

const vendaOnline = (
  <svg width='38' height='39' viewBox='0 0 38 39' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.9418 24.1224V11.124C13.9418 9.75826 13.0321 8.65039 11.9125 8.65039C10.7928 8.65039 9.88312 9.76782 9.88312 11.124V26.1185C9.88312 26.1185 9.86563 26.7966 9.62071 26.9208C9.36705 27.0545 9.10463 27.1022 8.85097 26.8921C8.72851 26.7966 8.60605 26.6915 8.50983 26.5769C8.02874 26.0134 7.39895 25.7174 6.76041 25.45C5.66702 24.9915 4.53865 24.8101 3.37529 24.8578C2.66677 24.8865 2.02823 25.0966 1.42468 25.5073C0.908604 25.8702 0.917351 26.596 1.16227 27.0354C1.45967 27.5798 1.99324 27.7517 2.45684 28.0382C3.18285 28.4871 3.9351 28.8977 4.63487 29.3753C5.16844 29.7382 5.66702 30.168 6.14812 30.6169C6.82164 31.2472 7.47767 31.9062 8.11621 32.5843C8.93844 33.4629 9.61197 34.4753 10.233 35.5259C10.233 35.5259 11.3089 37.9899 13.2158 37.9899H21.3593C21.3593 37.9899 25.0681 38.8591 25.0681 24.4758V21.3909C25.0681 20.2067 24.2371 19.242 23.2137 19.242C22.1903 19.242 21.3593 20.2067 21.3593 21.3909V24.4758'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M17.6512 24.1031V18.3823C17.6512 17.198 16.8202 16.2334 15.7968 16.2334C14.7734 16.2334 13.9424 17.198 13.9424 18.3823V24.1031'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M17.6514 24.5043V19.729C17.6514 18.5447 18.4823 17.5801 19.5058 17.5801C20.5292 17.5801 21.3601 18.5447 21.3601 19.729V24.5043'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M25.5403 17.9811C25.5403 15.9564 21.8053 14.3232 17.1956 14.3232V4.08496C21.8053 4.08496 25.5403 5.72767 25.5403 7.74286H25.5928C25.5928 5.71812 29.3278 4.08496 33.9375 4.08496V14.3232C29.3278 14.3232 25.5928 15.966 25.5928 17.9811H25.5403Z'
      stroke='#677484'
      stroke-miterlimit='10'
    />
    <path
      d='M8.55445 24.5041C7.36485 24.5041 6.39392 23.5109 6.39392 22.2979V3.2062C6.39392 1.99327 7.36485 1 8.55445 1H34.8395C36.0291 1 37 1.99327 37 3.2062V22.2979C37 23.5109 36.0291 24.5041 34.8395 24.5041H26.0137'
      stroke='#677484'
      stroke-miterlimit='10'
    />
  </svg>
)
